window.ModeTableLive = (function () {
    const selectors = {
        betPlace: '#bet-place',
        table: '.events-table',
        header: '.events-table__header',
        resultsLine: '[tb-resline]',
        event: '.events-table__body-row',
        eventTitle: '.events-table__title',
        eventAllCoefsCount: '.events-table__all-coefs-count',
        cell: '.events-table__markets-cell',
        scrollbarContentWrapper: '.m-page-content-scrollbar > .awesome-scrollbar__content-wrapper',
        eventCoefs: '.events-table__row-coefs',
        expandAllCoefsButton: '.js-expand-all-coefs',
        sportsFilterItem: '.sports-filter__item',
        expandNestedEventsButton: '.js-expand-nested-events'
    };

    const topHeight = {
        bannerHeight: $('#mobile-app-banner').height(),
        headHeight: $('#app-header').height(),
        headerWithBanner: null
    };
    topHeight.headerWithBanner = topHeight.bannerHeight + topHeight.headHeight;
    const visibilityArea = $(window).height();
    const isClientCartEnabled = window?.globalAppSettings?.isClientCartEnabled;

    function removeFromCart(oId) {
        if (isClientCartEnabled) {
            window.ClientCart.removeOutcome(Number(oId));
        } else {
            BettingCart.removeItem(oId);
        }
    }

    function addToCart(sData) {
        if (isClientCartEnabled) {
            window.ClientCart.addOutcome({
                oId: Number(sData.oId),
                eId: Number(sData.eId),
            });
        } else {
            BettingCart.addItem(sData);
            BettingCart.Highlighting.activate.allScopes();
        }
    }

    function highlightCoef() {
        if (isClientCartEnabled) {
            window.ClientCart.highlight();
        } else {
            BettingCart.Highlighting.activate.table();
        }
    }

    var Table = (function () {
        var Table = function (domTable) {
            this.id = domTable.data('sportid');
            this.domTable = domTable;
            this.header = domTable.find(selectors.header);
            this.isFavorite = domTable.hasClass('m-favorite');

            this.bindUI();
            SPA.updatePageLinks();
        };

        Table.prototype.bindUI = function () {
        };

        return Table;
    }());

    var tables = {},
        eventBlocks = {},
        pageContentScrollTop = 0,
        maxEventBlocksCount = 1;

    var bindUI = function () {

        // Fix table Header v3.0
        if (app.isIE()) {
            $(selectors.scrollbarContentWrapper).on('scroll.liveTable', function () {
                pageContentScrollTop = $(this).scrollTop();
                fixHeader(pageContentScrollTop);
            });
        }

        // Betting cart (add/remove) v3.0
        app.body.on('click', selectors.cell + '[data-aid]', function () {
            var that = $(this),
                coefOid = that.attr('data-oid');

            if (that.hasClass('active')) {
                removeFromCart(coefOid);
                return false;
            }

            var coefVal = that.attr('data-coefvalue'),
                coefAid = that.attr('data-aid');
            var event = that.closest(selectors.event),
                eventId = event.attr('data-id');
            var sData = {
                oId: coefOid,
                aId: coefAid,
                val: coefVal,
                isLive: true,
                eId: eventId,
            };

            // return false if cart is sending now or overflowed, return true if added or already added.  Blink on false
            addToCart(sData);

            return false;
        });

        app.body.on('click', selectors.expandNestedEventsButton, function () {
            var mainEventId = $(this).closest(selectors.event).data('id');
            var mainEventNode = $(this).closest(selectors.event);
            var isCollapsing = mainEventNode.hasClass('m-nested-expanded');

            var nestedEvents = document.querySelectorAll(`[data-meid="${mainEventId}"`);

            if (isCollapsing) {
                var isFavorites = $('#favorites-switcher').hasClass('m-selected');
                Ajax.postJson("/Live/HideNestedEvents", {
                    data: {
                        mainEventId: mainEventId,
                        isFavorites: isFavorites,
                    },
                    doCallAjaxViewParsers: false,
                    success: function (response) {
                        $(nestedEvents).each(function () {
                            var nestedEventNode = $(this).closest(selectors.event);
                            nestedEventNode.addClass('m-hidden');
                        });
                        mainEventNode.removeClass('m-nested-expanded');
                    }
                });
            }
            else {
                Ajax.postJson("/Live/ShowNestedEvents", {
                    data: {
                        mainEventId: mainEventId,
                    },
                    doCallAjaxViewParsers: false,
                    success: function (response) {
                        $(nestedEvents).each(function () {
                            var nestedEventNode = $(this).closest(selectors.event);
                            nestedEventNode.removeClass('m-hidden');
                        });
                        mainEventNode.addClass('m-nested-expanded');
                    }
                });
            }
            return false;
        })

        //Expand EventCoefs
        app.body.on('click', selectors.expandAllCoefsButton, function () {
            var eventNode = $(this).closest(selectors.event),
                coefsNode = eventNode.find(selectors.eventCoefs),
                isCollapsing = coefsNode.hasClass('m-visible'),
                id = eventNode.data('id');

            if ($('#mobile-app-banner').css('display') == 'none') {
                $('.events-table__row-main-info').css('top', topHeight.headHeight);
            } else {
                $('.events-table__row-main-info').css('top', topHeight.headerWithBanner);
            }

            //filter sticky

            if ($('.events-table__scoring', eventNode).length > 0) {
                $(eventNode).attr('data-filter-sticky', 'bigSpace');
            } else {
                $(eventNode).attr('data-filter-sticky', 'ordinarySpace');
            }

            if (isCollapsing) {
                eventNode.removeClass('m-expanded');
                disposeEventBlock(id);
                coefsNode.empty();
                coefsNode.removeClass('m-visible');
                Ajax.postJson('/Live/CollapseEventCoefs', { data: { id: id }, doCallAjaxViewParsers: false });



                let defaultPosition = $(eventNode).data('node-saved-top');
                let scrollEvent = $(window).scrollTop();
                if (defaultPosition == undefined) {
                    defaultPosition = scrollEvent;
                };

                let deltaScroll = Number(defaultPosition) - Number(scrollEvent);//direction scrollTop

                let positionEventBeforeCollapse = $(eventNode).offset().top;
                //scrollDefaultPosition
                if (globalAppSettings.isMobileDevice && !globalAppSettings.isMobileDeviceInDesktopMode) {

                    if ((deltaScroll < 0) && (scrollEvent > defaultPosition) && (scrollEvent > positionEventBeforeCollapse)) {
                        if ($('#mobile-app-banner').css('display') == 'none') {
                            $(window).scrollTop(eventNode.offset().top - topHeight.headHeight);
                        } else {
                            $(window).scrollTop(eventNode.offset().top - topHeight.headerWithBanner);
                        }
                    } else if (deltaScroll > 0 || scrollEvent < positionEventBeforeCollapse) {
                        $(window).scrollTop(scrollEvent);
                    } else {
                        $(window).scrollTop(defaultPosition);
                    }
                }

                return false;
            } else {
                $(eventNode).data('node-saved-top', $(window).scrollTop());
            }

            eventNode.addClass('m-expanded');
            eventNode.addClass('m-loading');
            Ajax.postJson("/Live/ExpandEventCoefs", {
                data: {
                    id: id,
                },
                doCallAjaxViewParsers: false,
                success: function (resp) {
                    var newCoefsNode = $(resp.html);
                    coefsNode.replaceWith(newCoefsNode);

                    initEventBlock(newCoefsNode);
                    if (!isClientCartEnabled) {
                        BettingCart.Highlighting.activate.openEvent();
                    } else {
                        window.ClientCart.highlight();
                    }

                    if (Object.keys(eventBlocks).length > maxEventBlocksCount) {
                        var minEventBlock = Object.values(eventBlocks).reduce(function (acc, val) { return (val.orderValue < acc.orderValue) ? val : acc; }, { orderValue: Infinity });

                        minEventBlock.domNode.closest(selectors.event).removeClass('m-expanded');
                        minEventBlock.domNode.empty();
                        minEventBlock.domNode.removeClass('m-visible');
                        disposeEventBlock(minEventBlock.id);
                    }

                    dispatchShowEventsListCoefsEvent();
                    eventNode.removeClass('m-loading');
                }
            });
            return false;
        });
    };

    var dispatchShowEventsListCoefsEvent = function () {
        let ids = $(selectors.event + '.m-expanded').map(function () {
            return $(this).attr('data-id');
        }).toArray();

        if (ids.length > 0) {
            console.log('dispatchShowEventsListCoefsEvent');
            document.dispatchEvent(new CustomEvent('showEventsListCoefs', {
                detail: {
                    ids: ids
                }
            }));
        } else {
            document.dispatchEvent(new CustomEvent('stopShowingEventsListCoefs'));
        }
    };

    var unbindUI = function () {
        app.body
            .off('click', selectors.cell + '[data-aid]')
            .off('click', selectors.expandAllCoefsButton)
            .off('click', selectors.expandNestedEventsButton);

        if (app.isIE()) {
            $(selectors.scrollbarContentWrapper).off('scroll.liveTable');
        }
    };

    var init = (function () {
        $(selectors.table).each(function () {
            var self = $(this);
            var id = $(this).data('sportid');

            tables[id] = new Table(self);
        });

        highlightCoef();

        setTimeout(function () {
            $(selectors.scrollbarContentWrapper).scrollTop(sessionStorage.getItem('livePageContentScrollTop') || 0)
        }, 10);

        bindUI();
        if (!isEmpty()) {
            TableFetcherLive.start();
        }

        maxEventBlocksCount = globalAppSettings.liveTableMaxExpandedEvents || 1;
    });

    var fixHeader = function (scrollTop) {
        for (key in tables) {
            var table = tables[key];
            var top = table.domTable.position().top + parseInt(table.domTable.css('margin-top')) + 10;
            var height = table.domTable.outerHeight();

            if (scrollTop > top && scrollTop < top + height - 25) {
                table.header.css({
                    transform: 'translateY(' + (scrollTop - (top + 2)) + 'px)'
                });
            } else {
                table.header.css({
                    transform: 'translateY(0)'
                });
            }
        }
    };

    var update = function () {
        clear();
        dispatchShowEventsListCoefsEvent();

        $(selectors.table).each(function () {
            var self = $(this);
            var id = $(this).data('sportid');

            tables[id] = new Table(self);

            //filter sticky
            if ($('.events-table__scoring', self).length > 0) {
                $('.events-table__body-row.m-expanded', self).attr('data-filter-sticky', 'bigSpace');
            } else {
                $('.events-table__body-row.m-expanded', self).attr('data-filter-sticky', 'ordinarySpace');
            }
        });

        highlightCoef();

        $(selectors.scrollbarContentWrapper).scroll();

        if (isEmpty()) {
            $('#live-empty_betplace').addClass('active');
        } else {
            TableFetcherLive.start();

            if ($('#mobile-app-banner').css('display') == 'none') {
                $('.events-table__row-main-info').css('top', topHeight.headHeight);
            } else {
                $('.events-table__row-main-info').css('top', topHeight.headerWithBanner);
            }
        }

        initEventBlocks();
    };

    var destroyTables = function () {
        for (var key in tables) {
            tables[key].domTable.remove();
            delete tables[key];
        }
    };

    var removeTable = function (id) {
        var table = tables[id];
        if (table !== undefined) {
            table.domTable.remove();
            delete tables[id];
        }
        if (!isEmpty()) {
            TableFetcherLive.start();
        }

        initEventBlocks();
    };

    var clear = function () {
        for (var key in tables) {
            tables[key].domTable.remove();
            delete tables[key];
        }
    };

    var dispose = function () {
        TableFetcherLive.stop();
        clear();
        unbindUI();
        disposeEventBlocks();
        sessionStorage.setItem('livePageContentScrollTop', pageContentScrollTop);
    };

    var insertTable = function (html, insertAfterId) {
        var self = $(html);
        var id = self.data('sportid');

        if (tables[id] != undefined) {
            tables[id].domTable.remove();
            delete tables[id];
        }

        if (insertAfterId !== undefined) {
            var insertAfterTable = tables[insertAfterId];
            (insertAfterTable !== undefined) ? self.insertAfter(insertAfterTable.domTable) : $(selectors.betPlace).prepend(self);
        }
        else {
            $(selectors.betPlace).prepend(self);
        }

        tables[id] = new Table(self);

        highlightCoef();

        if (!isEmpty()) {
            dispatchShowEventsListCoefsEvent();
            TableFetcherLive.start();
        }
    };

    var disposeEventBlocks = function () {
        for (var key in eventBlocks) {
            disposeEventBlock(key);
        }
        eventBlocks = {};
    }

    var initEventBlocks = function () {
        disposeEventBlocks();
        var wrapperNodes = $(selectors.eventCoefs + '.m-visible');
        if (wrapperNodes.length > 0) {
            wrapperNodes.each(function () {
                initEventBlock($(this));
            });

            if (isClientCartEnabled) {
                window.ClientCart.highlight();
            } else {
                BettingCart.Highlighting.activate.openEvent();
            }
        }
    }

    function disposeEventBlock(id) {
        if(!eventBlocks[id]) {
            return
        }
        eventBlocks[id].dispose();
        delete eventBlocks[id];
        BinderTextScroll.unbindScroll(id);
    }

    function initEventBlock(node) {
        var eventBlock = new EventBlock(node, EventBlock.EType.LiveTable);
        BinderTextScroll.bindScroll(eventBlock.domNode);

        if (eventBlock.id) {
            var maxOrderValue = Math.max.apply(null, Object.values(eventBlocks).map(function (x) { return x.orderValue }));
            eventBlock.orderValue = (maxOrderValue == -Infinity) ? 0 : maxOrderValue + 1;
            eventBlocks[eventBlock.id] = eventBlock;
            //new AwesomeScrollbar('[data-event-id="' + eventBlock.id + '"] [js-node="accent-event-body"]', 'm-accent-event');
        }
    }

    function getEventBlockInstanceById(eventId) {
        return (eventBlocks.hasOwnProperty(eventId)) ? eventBlocks[eventId] : null;
    }

    const DEFER_TIMEOUT = 1500;
    var timeoutPool = {};
    function deferAction(key, action) {
        clearTimeout(timeoutPool[key]);
        timeoutPool[key] = setTimeout(function () {
            action();
            delete timeoutPool[key];
        }, DEFER_TIMEOUT);
    }

    var count = function () { return Object.keys(tables).length };
    var isEmpty = function () { return count() === 0 };

    return {
        'tables': tables,
        'count': count,
        'init': init,
        'dispose': dispose,
        'isEmpty': isEmpty,
        'update': update,
        'clear': clear,
        'removeTable': removeTable,
        'destroyTables': destroyTables,
        'insertTable': insertTable,
        'selectors': selectors
    };
}());